import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { TechnologyReportSearchRequest } from "../models/technologyReport.model";
import { technologyReportService } from "../services/technologyReportService";

/**
 * Runs the By Skills & Technologies report search. `request` is null until the user clicks
 * "Run Report" — an empty/unset filter must never auto-query (FS_05_Reporting_01 — empty
 * filter = no-op, not "match everyone"). Independent of the certificate report's hook.
 *
 * `runId` forces a fresh fetch on every explicit "Run Report" click — same pattern as
 * `useCertificateReportSearch`. See that hook's doc comment for the full rationale.
 */
export const useTechnologyReportSearch = (
    request: TechnologyReportSearchRequest | null,
    runId = 0
) => {
    return useQuery({
        queryKey: ["reports", "technology", "search", request, runId],
        queryFn: () => technologyReportService.search(request as TechnologyReportSearchRequest),
        enabled: request !== null,
        placeholderData: keepPreviousData,
    });
};
